import React, {Fragment} from "react";

import {
	useLocalStore,
	Loaders,
	setupLoaders,
} from '../data';
import {Video} from "./connect";
import {
	Card,
	AddLink,
	LoadingSpinner,
	ErrorBoundary,
	Button,
	Modal,
	useRelayErrors,
	ErrorStripe,
	FormGroup,
	InputComponent,
	DeleteModalComponent,
	FunnelsListPickerApp,
} from './';

type Props = {
	close: () => void
	loading: boolean
	action: (a, b) => void
}

export function Upgrade(props: Props){
	const [onError, errors, setErrors] = useRelayErrors();
	const [state, onChange] = useLocalStore({
		token: "",
		secret: "",
	});
	return (
		<Modal
			close={() => {
				props.close();
			}}
			title="Connect to Shopify"
			footer={
				<Fragment>
					<Button
						className="cancelButton"
						onClick={() => {
							props.close();
						}}
					>
						Cancel
					</Button>
					<Button
						children="Save"
						primary
						disabled={!state.token}
						spinning={props.loading}
						onClick={
							function () {
								if(props.loading){
									return;
								}
								setErrors([]);
								props.action(state, onError);
							}
						}
					/>
				</Fragment>
			}
		>
			{
				errors[""] && (
					<ErrorStripe message={errors[""]} />
				)
			}
			<div className="mb-2">Enter your Shopify store credentials to connect it to Lightfunnels.</div>
			<Video />
			<FormGroup label="Access Token">
				<InputComponent
					placeholder=""
					error={errors['token']}
					onChange={onChange}
					value={state.token}
					name="token"
				/>
			</FormGroup>

			<FormGroup label="App Secret">
				<InputComponent
					placeholder=""
					error={errors['secret']}
					onChange={onChange}
					value={state.secret}
					name="secret"
				/>
			</FormGroup>
		</Modal>
	)
}